import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setAccessDeleteError, setLoading } from "../../repository/slice";

function* deleteAccessWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.delete, "/api/access/", payload);
        if (isError) {
            yield put(setAccessDeleteError(message));
        } else {
            yield put(setAccessDeleteError(null));
        }
    } catch (error) {
        console.error("deleteAccessWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* deleteAccessWatcher() {
    yield takeLatest("@saga/DELETE_ACCESS", deleteAccessWorker);
};